import React, { useEffect } from 'react';
import "../../styles/reg-courses/main.css";

const Main = () => {
    useEffect(() => {
        showRegularCourses();
    }, []);

    const showRegularCourses = () => {
        const regularTab = document.getElementById('regular-tab');
        const regularCourses = document.getElementById('regular-courses');
        const selfFinanceTab = document.getElementById('self-finance-tab');
        const selfFinanceCourses = document.getElementById('self-finance-courses');

        regularCourses.style.display = 'flex';
        regularTab.style.backgroundColor = '#14297a';
        regularTab.style.color = '#ffffff';
        selfFinanceCourses.style.display = 'none';
        selfFinanceTab.style.backgroundColor = '#f0f6fd';
        selfFinanceTab.style.color = '#8d9093';
    };

    const showSelfFinanceCourses = () => {
        const regularTab = document.getElementById('regular-tab');
        const regularCourses = document.getElementById('regular-courses');
        const selfFinanceTab = document.getElementById('self-finance-tab');
        const selfFinanceCourses = document.getElementById('self-finance-courses');

        selfFinanceCourses.style.display = 'flex';
        selfFinanceTab.style.backgroundColor = '#14297a';
        selfFinanceTab.style.color = '#ffffff';
        regularCourses.style.display = 'none';
        regularTab.style.backgroundColor = '#f0f6fd';
        regularTab.style.color = '#8d9093';
    };

    return (
        <div id='regCoursesMain' className='mb-4'>
            <div className="container mt-5">
                <p id="respara">
                    <b>Courses</b>/Regular Courses/Self Finance Courses
                </p>
                <div style={{ display: "flex", flexDirection: "row", paddingLeft: 20 }}>
                    <div id="regular-tab" onClick={showRegularCourses}>
                        Regular Courses
                    </div>
                    <div id="self-finance-tab" onClick={showSelfFinanceCourses}>
                        Self Finance Courses
                    </div>
                </div>

                <div id="regular-courses">
                    <div>
                        <div className="course-title" id="c-titile">
                            Courses Being Offered In the Campus
                        </div>
                        <div className="Box">
                            <div className="box-container">
                                <div className="overlay-1" />
                                <div className="course">B.Sc. (NEP)</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Botany</div>
                                    <div>Statistics</div>
                                    <div>Mathamatics</div>
                                    <div>Chemistry</div>
                                    <div>Zoology</div>
                                    <div>Physics</div>
                                </div>
                            </div>
                            <div className="box-container">
                                <div className="overlay-2" />
                                <div className="course">M.Sc. (NEP)</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Botany</div>
                                    <div>Physics</div>
                                    <div>Statistics</div>
                                    <div>Chemistry</div>
                                    <div>Microbiology</div>
                                    <div>Zoology</div>
                                    <div>Mathamatics</div>
                                    <div>Toxicology</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="course-title" id="c-title">
                            Faculty of Arts
                        </div>
                        <div className="Box">
                            <div className="box-container">
                                <div className="overlay-2" />
                                <div className="course">B.A. (NEP)</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>English</div>
                                    <div>Hindi</div>
                                    <div>Political Science</div>
                                    <div>Economics</div>
                                    <div>History</div>
                                    <div>Psychology</div>
                                    <div>Sociology</div>
                                    <div>Sanskrit</div>
                                </div>
                            </div>
                            <div className="box-container">
                                <div className="overlay-1" />
                                <div className="course">M.A.</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>English</div>
                                    <div>Political Science</div>
                                    <div>Urdu</div>
                                    <div>Economics</div>
                                    <div>Psychology</div>
                                    <div>History</div>
                                    <div>Hindi</div>
                                    <div>Sanskrit</div>
                                    <div>Sociology</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="course-title">Faculty of Education</div>
                        <div className="box">
                            <div className="box-container">
                                <div className="course-div">
                                    <div className="overlay-2" />
                                    <div className="course">M.Ed. (NEP)</div>
                                    {/* Grid-Box */}
                                    <div className="grid-container">
                                        <div>Botany</div>
                                        <div>Physics</div>
                                        <div>Statistics</div>
                                        <div>Chemistry</div>
                                        <div>Microbiology</div>
                                        <div>Zoology</div>
                                        <div>Mathamatics</div>
                                        <div>Toxicology</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="course-title">Faculty of Agriculture</div>
                        <div className="box">
                            <div className="box-container">
                                <div className="course-div">
                                    <div className="overlay-1" />
                                    <div className="course">M.Ed. (NEP)</div>
                                    {/* Grid-Box */}
                                    <div className="grid-container">
                                        <div>Genetics &amp; Plant Breeding</div>
                                        <div>Horticulture</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="self-finance-courses">
                    <div>
                        <div id="selfHead">Self Finance Courses Being Offered In the Campus</div>
                        <div className="Box">
                            <div className="box-container">
                                <div className="overlay-1" />
                                <div className="course">Certificate Courses</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Proficiency in French</div>
                                    <div>Proficiency in Russian</div>
                                </div>
                            </div>
                            <div className="box-container">
                                <div className="overlay-2" />
                                <div className="course">Diploma Courses</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Botany</div>
                                    <div>Physics</div>
                                    <div>Statistics</div>
                                    <div>Chemistry</div>
                                    <div>Microbiology</div>
                                    <div>Zoology</div>
                                    <div>Mathamatics</div>
                                    <div>Toxicology</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="Box">
                            <div className="box-container">
                                <div className="overlay-1" />
                                <div className="course">M.A.</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Public Administration</div>
                                    <div>Geography</div>
                                </div>
                            </div>
                            <div className="box-container">
                                <div className="overlay-2" />
                                <div className="course">M.Sc. (Ag.)</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Food Science &amp; Technology</div>
                                    <div>Plant Pathology</div>
                                    <div>Entomology</div>
                                    <div>Seed Science &amp; Technology</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="Box">
                        <div className="box-container">
                            <div className="overlay-1" />
                            <div className="course">M.Sc.</div>
                            {/* Grid-Box */}
                            <div className="grid-container">
                                <div>Environmental Science</div>
                                <div>Bio-Technology</div>
                                <div>Bio-Chemistry</div>
                                <div>Polymer Science &amp; Chemical Technology</div>
                                <div>Applied Microbiology</div>
                                <div>Medical Microbiology</div>
                                <div>Bioinformatics</div>
                                <div>Food Nutrition</div>
                            </div>
                        </div>
                        <div className="box-container">
                            <div className="overlay-2" />
                            <div className="course">Professional Courses</div>
                            {/* Grid-Box */}
                            <div className="grid-container">
                                <div>Master of Journalism and Mass Communication (MJMC)</div>
                                <div>Master of Fine Arts (Applied Arts )</div>
                                <div>Master of Fine Arts (Drawing and Painting)</div>
                                <div>Master of Library &amp; Information Science (MLISc.)</div>
                                <div>Master of Physical Education (MPEd.)</div>
                                <div>Bachelor of Physical Education (BPEd.)</div>
                                <div>LL.M.</div>
                                <div>B.A. LL.B.(Five-Years)</div>
                            </div>
                        </div>
                    </div>
                    <div className="Box">
                        <div className="box-container">
                            <div className="overlay-1" />
                            <div className="course">P.G.Courses</div>
                            {/* Grid-Box */}
                            <div className="grid-container">
                                <div>Master of Business Administration (M.B.A)</div>
                                <div>M.B.A. Hospital Administration</div>
                                <div>Master of Computer Applications (MCA)</div>
                                <div>Master of Social Work (MSW)</div>
                            </div>
                        </div>
                        <div className="box-container">
                            <div className="overlay-2" />
                            <div className="course">P.G. Diploma Courses</div>
                            {/* Grid-Box */}
                            <div className="grid-container">
                                <div>Communication Skills in English (From Session 2022-23)</div>
                                <div>GIS &amp; Remote Sensing</div>
                                <div>Film Production</div>
                                <div>Yoga Science</div>
                                <div>Jyotir Vigyan</div>
                                <div>Karam Kand</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="course-title">U.G. Courses</div>
                        <div className="Box">
                            <div className="box-container">
                                <div className="overlay-2" />
                                <div className="course">B.Tech</div>
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>Information Technology</div>
                                    <div>Computer Science</div>
                                    <div>Electronics &amp; Communication</div>
                                    <div>Mechanical Engineering</div>
                                    <div>Agriculture Engineering</div>
                                    <div>Chemical Engineering</div>
                                </div>
                            </div>
                            <div className="box-container">
                                <div className="overlay-1" />
                                {/* Grid-Box */}
                                <div className="grid-container">
                                    <div>B.Sc. (Hons.) Computer Science</div>
                                    <div>B.Sc. (Hons.) Chemistry (From Session 2022-23)</div>
                                    <div>B.Com. (Hons.)</div>
                                    <div>B.A. (Hons.) Economics (From Session 2022-23)</div>
                                    <div>B.A. (Hons.) Hindi (From Session 2022-23)</div>
                                    <div>B.B.A.</div>
                                    <div>B.B.A.(H.A.)</div>
                                    <div>B.Sc. (Food Microbiology and Safety Control)</div>
                                    <div>B.A.(J.M.C.)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;